export enum ERegExpTypes {
  password = '(?=.*[A-Z])(?=.*[!@#\\$%\\^&\\*])(?=.{8,})',
  onlyDigits = '^\\d+$',
  '4digits' = '^[0-9]{4}$',
  'mm/dd/yyyy' = '^(0[1-9]|1[0-2])\\/(0[1-9]|1\\d|2\\d|3[01])\\/(19|20)\\d{2}$',
}
